// extracted by mini-css-extract-plugin
module.exports = {"content":"footer-module--content--3f5hY"};